<template>
  <common-dialog ref="dialog" width="800px" title="日志明细" form-label-width="85px">
    <template slot="form">
      <el-table :data="data" border>
        <el-table-column label="学生编号" prop="StudentNumber" />
        <el-table-column label="学生姓名" prop="FullName" />
        <el-table-column label="是否缺勤" width="80" align="center">
          <template slot-scope="{row}">
            <el-tag type="danger" v-if="row.AttendanceDtsId != 0 || row.IsLeave || row.IsMedical">是</el-tag>
            <el-tag v-else type="success">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="缺勤原因" min-width="120">
          <template slot-scope="{row}">
            <span v-if="row.IsLeave">{{row.LeaveType}}</span>
            <span v-if="row.IsLeave&&row.IsMedical">、</span>
            <span v-if="row.IsMedical">{{row.MedicalRemark}}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="RollcallRemark" min-width="140" />
      </el-table>
    </template>
    <template slot="footer">
      <el-button size="mini" @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import detailsDialogMixin from "@/mixins/detailsDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [detailsDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require("@/api/at/attendance").default,
      data: [],
    };
  },
  computed: {},
  methods: {
    getData(row) {
      console.log('row',row)
      // var termId = row.TermId;
      // var classId = row.ClassId;
      // var id = row.AttendanceId;
      // var dtsId = row.TimetableDtsId;
      var params = {
        TermId: row.TermId,
        ClassId: row.ClassId,
        AttendanceId: row.AttendanceId,
        TimetableDtsId: row.TimetableDtsId,
      };
      this.$refs.dialog.isLoading = true;
      this.api.getStudentsV3(params).then((res) => {
        this.$refs.dialog.isLoading = false;
        this.data = res.Data;
        console.log("获取学生", this.data);
      });
    },
  },
};
</script>